<template>
  <!-- custom video: -->
  <div :class="['video_outer_master', isBrowserFullscreen? 'video_outer_for_browser_full_screen': '']" @mouseenter="mouseenterForVideoOuterMaster" @mousemove="mousemoveForVideoOuterMaster" @mouseleave="mouseleaveForVideoOuterMaster">
    <div :class="['video_outer', isBrowserFullscreen ? 'for_browser_full_screen' : '']">
      <!-- video: -->
      <div class="video_real">
        <video 
          ref="refForVideo"
          id="idForVideo"
          :style="{ objectFit: options.objectFit }"
          :src="options.src"
          :poster="options.poster"
          @canplay="videoCanplay"
          @timeupdate="videoTimeupdate"
          @ended="videoEnded"
        ></video>
      </div>
      <!-- pause mask: -->
      <!-- <div class="pause_mask" v-if="!isPlaying && showForVideoOperationBar"> -->
      <div class="pause_mask" v-if="!isPlaying">
        <div class="pause_mask_btn" @click="playOrPouse">
          <img :src="!isPlaying ? require('../../assets/img/myVideo/icon_bofang_24@2x.png') : require('../../assets/img/myVideo/icon_zanting_24@2x.png')">
        </div>
        <div class="pause_mask_bottom"></div>
      </div>
      <!-- operation bar: -->
      <div class="video_operation_bar" v-if="showForVideoOperationBar">
        <div class="video_operation_bar_for_play_bar">
          <div class="video_operation_bar_for_play_bar_real" @click="clickForBar">
            <div class="video_operation_bar_for_play_bar_real_inner" :style="{ width: barWidth }"></div>
          </div>
        </div>
        <!-- left: -->
        <div class="video_operation_bar_for_left">
          <!-- play or pouse: -->
          <div class="play_or_pouse" @click="playOrPouse">
            <img :src="!isPlaying ? require('../../assets/img/myVideo/icon_bofang_24@2x.png') : require('../../assets/img/myVideo/icon_zanting_24@2x.png')">
          </div>
          <!-- refresh: -->
          <div class="refresh" @click="refresh" v-show="options.refresh">
            <img src="../../assets/img/myVideo/icon_shuaxin_24@2x.png">
          </div>
          <!-- time: -->
          <div class="time" v-show="options.time">
            <div class="time_start">{{totalTime}}</div>
            <div class="time_cut_off">/</div>
            <div class="time_end">{{currentTime}}</div>
          </div>
        </div>
        <!-- right: -->
        <div class="video_operation_bar_for_right">
          <!-- definition: -->
          <div class="definition" @mouseenter="mouseenterForRightItem('definition')" v-show="options.definition">
            <span>{{options.definitionActive}}</span>
            <div class="definition_list" v-show="showForRightItemList === 'definition'" @mouseleave="mouseleaveForRightItem()">
              <span :class="['list_item', item.value === options.definitionActive ? 'active' : '']" v-for="item in options.definitionList" :key="item.key" @click="changeTheDefinition(item)">{{item.value}}</span>
            </div>
          </div>
          <!-- playbackRate: -->
          <div class="playbackRate" @mouseenter="mouseenterForRightItem('playbackRate')" v-show="options.playbackRate">
            <span>倍速</span>
            <div class="playbackRate_list" v-show="showForRightItemList === 'playbackRate'" @mouseleave="mouseleaveForRightItem()">
              <span :class="['list_item', item.key === playbackRateActive ? 'active' : '']" v-for="item in playbackRateList" :key="item.key" @click="changeThePlaybackRate(item)">{{item.key}}x</span>
            </div>
          </div>
          <!-- section: -->
          <div class="section" @mouseenter="mouseenterForRightItem('section')" v-show="options.section">
            <span>章节</span>
            <div class="section_list" v-show="showForRightItemList === 'section'" @mouseleave="mouseleaveForRightItem()">
              <span :class="['list_item', item.key === options.sectionActive ? 'active' : '']" v-for="item in options.sectionList" :key="item.key" @click="changeTheSection(item)">{{item.value}}</span>
            </div>
          </div>
          <!-- volume: -->
          <div class="volume" @mouseenter="mouseenterForRightItem('volume')" v-show="options.volume">
            <img :src="isMuted ? require('../../assets/img/myVideo/icon_yinliangclose_24@2x.png') : require('../../assets/img/myVideo/icon_yinliang_24@2x.png')" @click="operationForClickVolume">
            <div class="volume_bar" v-show="showForRightItemList === 'volume'" @mouseleave="mouseleaveForRightItem()">
              <div class="volume_bar_real">
                <div class="volume_bar_real_inner" :style="{ height: volumeBarRealInnerHeight }"></div>
                <div class="volume_bar_real_inner_dot" :style="{ top: volumeBarRealInnerDotTop }" @mousedown="mousedownForvolumeBarDot"></div>
              </div>
            </div>
          </div>
          <!-- browser full screen: -->
          <div class="browser_full_screen" @click="browserFullScreen" v-show="options.browserFullScreen">
            <img :src="isBrowserFullscreen ? require('../../assets/img/myVideo/icon_shouqiwangye_24@2x.png') : require('../../assets/img/myVideo/icon_wangyequanping_24@2x.png')">
          </div>
          <!-- full screen: -->
          <div class="full_screen" @click="fullscreen" v-show="options.fullscreen">
            <img :src="isFullscreen ? require('../../assets/img/myVideo/icon_shouqiquanping_24@2x.png') : require('../../assets/img/myVideo/icon_quanping_24@2x.png')">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// dispose second:
const secondsFormat = s => {
  s = Math.floor(s)
  const hour = Math.floor(s / 3600)
  const minute = Math.floor(s % 3600 / 60)
  const second = Math.floor(s % 60)
  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`
}
export default {
  name: 'customVideo',
  data() {
    return {
      videoDOM: null,
      // is playing:
      isPlaying: false,
      // the bar right show for who:
      showForRightItemList: '',
      // the operation bar show:
      showForVideoOperationBar: false,
      // the operation bar show of timerId:
      timerIdForShowForVideoOperationBar: 0,
      // the operation bar mouse no move when enter:
      mouseNoMoveWhenEnter: false,
      // is browser fullscreen:
      isBrowserFullscreen: false,
      // is fullscreen:
      isFullscreen: false,
      // time and bar:
      totalTime: '00:00:00',
      currentTime: '00:00:00',
      barWidth: '0%',
      // playbackRate about:
      playbackRateList: [
        {
          key: '2.0',
          value: 2.0 
        },
        {
          key: '1.5',
          value: 1.5 
        },
        {
          key: '1.0',
          value: 1.0 
        },
        {
          key: '0.5',
          value: 0.5 
        }
      ],
      playbackRateActive: '1.0',
      // volume about:
      isMuted: false,
      volumeBarRealInnerHeight: '65px',
      volumeBarRealInnerDotTop: '65px',
      volume: 0.5,
      // volume Backups about:
      volumeBarRealInnerHeightOfBackups: '65px',
      volumeBarRealInnerDotTopOfBackups: '65px',
      volumeOfBackups: 0.5
    }
  },
  props: {
    options: {
      type: Object,
      default: {}
    }
  },
  mounted () {
    const _that = this
    this.videoDOM = document.querySelector('#idForVideo')
    this.videoDOM.currentTime = this.options.currentTime
    document.onmouseup = function () {
      document.onmousemove = null
    }
    window.addEventListener('resize', function () {
      if (document.fullscreenElement) {
        _that.isFullscreen = true
      } else {
        _that.isFullscreen = false
      }
    })
    window.addEventListener('keyup', function (e) {
      if (e.keyCode === 27) {
        _that.isBrowserFullscreen = false
      }
    })
    this.$once('hook:beforeDestroy', () => {
      this.timerIdForShowForVideoOperationBar && clearTimeout(this.timerIdForShowForVideoOperationBar)
    })
  },
  methods: {
    // play or pouse：
    playOrPouse () {
      if (!this.isPlaying) {
        this.videoDOM.play()
      } else {
        this.videoDOM.pause()
      }
      this.isPlaying = !this.isPlaying
    },
    // refresh:
    refresh () {
      const src = this.videoDOM.src
      this.videoDOM.src = ''
      this.videoDOM.src = src
      this.videoDOM.play()
      this.isPlaying = true
    },
    // get duration time; set the first volume：
    videoCanplay () {
      const { duration } = this.videoDOM
      this.totalTime = secondsFormat(duration)
      this.videoDOM.volume = this.volume
    },
    // time update:
    videoTimeupdate () {
      const { currentTime, duration } = this.videoDOM
      this.currentTime = secondsFormat(currentTime)
      this.barWidth = currentTime / duration * 100 + '%'
    },
    // ended:
    videoEnded () {
      this.videoDOM.currentTime = 0
      this.isPlaying = false
    },
    // change the definition:
    changeTheDefinition (item) {
      this.$parent.options.definitionActive = item.value
    },
    // change the playbackRate:
    changeThePlaybackRate (item) {
      const { key, value } = item
      this.playbackRateActive = key
      this.videoDOM.playbackRate = value
      this.showForRightItemList = ''
    },
    // change the section:
    changeTheSection (item) {
      if (this.$parent.options) {
        this.$parent.options.sectionActive = item.key
        this.$parent.options.src = item.videoUrl
      } else if (this.$parent.$parent.options) {
        this.$parent.$parent.options.sectionActive = item.key
        this.$parent.$parent.options.src = item.videoUrl
      }
      this.videoDOM.currentTime = 0
      this.videoDOM.pause()
      setTimeout(() => {
        if (this.isPlaying) {
          this.videoDOM.play()
        }
      }, 30)
      this.showForRightItemList = ''
    },
    // set the volume：
    mousedownForvolumeBarDot (e) {
      const volumeBarReal = document.querySelector('.volume_bar_real')
      const volumeBarRealInnerDot = document.querySelector('.volume_bar_real_inner_dot')
      const difference = volumeBarReal.offsetHeight - volumeBarRealInnerDot.offsetHeight
      const _that = this
      const y = e.clientY - volumeBarRealInnerDot.offsetTop
      document.onmousemove = function (event) {
        event = event || window.event
        let top = event.clientY - y
        if (top < 0) {
          top = 0
        } else if (top > difference) {
          top = difference
        }
        _that.volumeBarRealInnerDotTop = _that.volumeBarRealInnerHeightOfBackups = top + 'px'
        _that.volumeBarRealInnerHeight = _that.volumeBarRealInnerDotTopOfBackups = (130 - top) + 'px'
        _that.volume = _that.volumeOfBackups = (100 - (top / difference) * 100) / 100
        _that.videoDOM.volume = _that.volume
        if (_that.volume > 0) {
          _that.isMuted = false
        } else {
          _that.isMuted = true
        }
      }
    },
    // click for volume:
    operationForClickVolume () {
      this.isMuted = !this.isMuted
      if (this.isMuted) {
        this.volumeBarRealInnerDotTop = '120px'
        this.volumeBarRealInnerHeight = '0px'
        this.videoDOM.volume = 0
        this.volume = 0
      } else {
        this.volumeBarRealInnerDotTop = this.volumeBarRealInnerHeightOfBackups
        this.volumeBarRealInnerHeight = this.volumeBarRealInnerDotTopOfBackups
        this.volume = this.volumeOfBackups
        this.videoDOM.volume = this.volume
      }
    },
    mouseenterForRightItem (who) {
      this.showForRightItemList = who    
    },
    mouseleaveForRightItem () {
      this.showForRightItemList = ''
    },
    // click for bar:
    clickForBar (e) {
      const { duration } = this.videoDOM
      const videoOperationBarForPlayBarReal = document.querySelector('.video_operation_bar_for_play_bar_real')
      const offset = e.offsetX
      const offsetWidth = videoOperationBarForPlayBarReal.offsetWidth
      this.videoDOM.currentTime = offset / offsetWidth * duration
    },
    // browser fullscreen:
    browserFullScreen () {
      this.isBrowserFullscreen = !this.isBrowserFullscreen
    },
    // fullscreen:
    fullscreen () {
      this.isFullscreen = !this.isFullscreen
      if (this.isFullscreen) {
        const element = document.querySelector(`.video_outer`)
        element && this.enterFullscreen(element)
      } else {
        this.exitFullscreen()
      }
    },
    // enter fullscreen:
    enterFullscreen (element) {
      if (element.requestFullScreen) {
        element.requestFullScreen()
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.msRequestFullScreen) {
        element.msRequestFullScreen()
      }
    },
    // exit fullscreen:
    exitFullscreen () {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.msCancelFullScreen) {
        document.msCancelFullScreen()
      }
    },
    mouseenterForVideoOuterMaster () {
      if (!this.mouseNoMoveWhenEnter) {
        this.showForVideoOperationBar = true
      }
    },
    mousemoveForVideoOuterMaster () {
      this.showForVideoOperationBar = true
      this.timerIdForShowForVideoOperationBar && clearTimeout(this.timerIdForShowForVideoOperationBar)
      this.timerIdForShowForVideoOperationBar = setTimeout(() => {
        this.showForVideoOperationBar = false
        this.mouseNoMoveWhenEnter = true
      }, 3000)
    },
    mouseleaveForVideoOuterMaster () {
      this.showForVideoOperationBar = false
      this.mouseNoMoveWhenEnter = false
    }
  }
}
</script>

<style lang="scss" scoped>
.video_outer_master {
  width: 100%;
  height: 100%;
  &.video_outer_for_browser_full_screen {
    background-color: #000;
    position: fixed;
    top:0;
    left:0;
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.video_outer {
  height: 100%;
  height: 100%;
  background-color: #000;
  position: relative;
  &.for_browser_full_screen {
    width: 80vw;
    height: calc((80vw / 800) * 450);
  }
  .video_real {
    width: 100%;
    height: 100%;
    background-color: #000;
    video {
      width: 100%;
      height: 100%;
    }
  }
  .pause_mask {
    width: 100%;
    height: calc(100% - 70px);
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    bottom: 70px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .pause_mask_btn {
      width: 80px;
      height: 80px;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      border: 1px solid #DDD;
      transform: translateY(25px);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
      img {
        width: 40px;
        height: 40px;
        display: block
      }
    }
    .pause_mask_bottom {
      width: 100%;
      height: 70px;
      background-color: rgba(0, 0, 0, 0.4);
      position: absolute;
      bottom: -70px;
      left: 0;
    }
  }
  .video_operation_bar {
    width: 100%;
    height: 50px;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .video_operation_bar_for_play_bar {
      width: 100%;
      height: 20px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.5) 100%);
      position: absolute;
      top: -20px;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      .video_operation_bar_for_play_bar_real {
        width: calc(100% - 32px);
        height: 4px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 2px;
        cursor: pointer;
        .video_operation_bar_for_play_bar_real_inner {
          height: 4px;
          background-color: #5F60D3;
          border-radius: 2px;
        }
      }
    }
    .video_operation_bar_for_left,
    .video_operation_bar_for_right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      user-select: none;
    }
    .video_operation_bar_for_left {
      .refresh {
        margin-left: 16px;
      }
      .time {
        display: flex;
        margin-left: 16px;
        color: #FFF;
        .time_cut_off {
          margin: 0 7px;
        }
      }
    }
    .video_operation_bar_for_right {
      .definition {
        color: #FFF;
        cursor: pointer;
        position: relative;
        font-size: 14px;
      }
      .playbackRate {
        margin-left: 16px;
        color: #FFF;
        cursor: pointer;
        position: relative;
        font-size: 14px;
      }
      .section {
        margin-left: 16px;
        color: #FFF;
        cursor: pointer;
        position: relative;
        font-size: 14px;
      }
      .volume {
        margin-left: 16px;
        position: relative;
        .volume_bar {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, calc(-100% - 40px));
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 150px;
          background-color: rgba(0, 0, 0, .5);
          border-radius: 4px;
          display: flex;
          cursor: auto;
          .volume_bar_real {
            width: 4px;
            height: 130px;
            background-color: #fff;
            border-radius: 1px;
            position: relative;
            .volume_bar_real_inner {
              width: 4px;
              background-color: #5F60D3;
              border-radius: 1px;
              position: absolute;
              bottom: 0;
            }
            .volume_bar_real_inner_dot {
              width: 10px;
              height: 10px;
              background-color: #5F60D3;
              position: absolute;
              left: 50%;
              transform: translate(-50%);
              border-radius: 50%;
              cursor: pointer;
            }
          }
        }
      }
      .browser_full_screen {
        margin-left: 16px;
      }
      .full_screen {
        margin-left: 16px;
      }
    }
    .play_or_pouse,
    .refresh,
    .volume,
    .browser_full_screen,
    .full_screen {
      width: 24px;
      height: 24px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .definition_list,
    .playbackRate_list,
    .section_list {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, calc(-100% - 40px));
      display: flex;
      flex-direction: column;
      height: auto;
      background-color: rgba(0, 0, 0, .5);
      padding: 6px 0;
      border-radius: 4px;
      font-size: 14px;
      .list_item {
        padding: 6px 12px;
        display: block;
        text-align: center;
        color: #9CA5B1;
        user-select: none;
        &:hover {
          color: #FFF;
        }
        &:active {
          color: #9CA5B1;
        }
        &.active {
          color: #FFF;
        }
      }
    }
    .definition_list,
    .playbackRate_list {
      width: 60px;
    }
    .section_list {
      width: 70px;
    }
  }
}
</style>
